import { PARCEL_BOOKING_REFRESH_EVENT } from "../types/parcelBookingSignalR.types";
import { getSignalRUserId } from "./jwtRole";
import {
  fetchParcelBookingHistoryByUserId,
  fetchUserBookingSummaryByUserId,
} from "../api/parcelBookingInformationApi";

/**
 * Refetches user dashboard APIs and notifies mounted components.
 */
export async function refreshCustomerDashboardData() {
  const userId = getSignalRUserId();
  if (!userId) return { history: null, summary: null };

  const [history, summaryRaw] = await Promise.all([
    fetchParcelBookingHistoryByUserId(userId),
    fetchUserBookingSummaryByUserId(userId),
  ]);

  const summary = Array.isArray(summaryRaw) ? summaryRaw[0] : summaryRaw;

  window.dispatchEvent(
    new CustomEvent(PARCEL_BOOKING_REFRESH_EVENT, {
      detail: { history, summary, userId },
    }),
  );

  return { history, summary };
}

export function dispatchCustomerDashboardRefresh(detail) {
  window.dispatchEvent(
    new CustomEvent(PARCEL_BOOKING_REFRESH_EVENT, { detail }),
  );
}
